import { Component, OnInit } from '@angular/core';
import { EndorsementInquirySearchHandler } from './endorsement-inquiry-search.handler';

import { Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { CompensationService } from '../services/compensation.service';

@Component({
  selector: 'endorsement-inquiry-search',
  templateUrl: './endorsement-inquiry-search.component.html',
  styleUrls: ['./endorsement-inquiry-search.component.scss'],
})
export class EndorsementInquirySearchComponent extends EndorsementInquirySearchHandler {
  constructor(
    public service: CompensationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
